<div>
	<h2>{{'csvLogs.titulo' | translate }}</h2>
	<section class="filters-framed" *ngIf="filtersVisible">
		<form [formGroup]="filtersForm" [ngClass]="{'show-error':showError}">
			<div [ngClass]="this.isSmallScreen ? 'entry-2-small' : 'entry-4'">
				<label>{{'csvLogs.filters.user' | translate}}</label>
				<input type="text" formControlName="userName">
			</div>
			<div [ngClass]="this.isSmallScreen ? 'entry-2-small' : 'entry-4'">
				<label>{{'csvLogs.filters.entityType' | translate}}</label>
				<app-filterable-list [itemsList]="csvTypes" [selectedItem]="filtersForm.get('csvType')"></app-filterable-list>
			</div>
            <div *ngIf="!this.isSmallScreen" [ngClass]="this.isSmallScreen ? 'entry-2-small' : 'entry-4'"></div>
            <div *ngIf="!this.isSmallScreen" [ngClass]="this.isSmallScreen ? 'entry-2-small' : 'entry-4'"></div>
			<div [ngClass]="this.isSmallScreen ? 'entry-2-small' : 'entry-4'">
				<label>{{'csvLogs.filters.maxRec' | translate}}</label>
				<input type="text" formControlName="maxRec">
			</div>
			<div [ngClass]="this.isSmallScreen ? 'entry-2-small' : 'entry-4'">
				<label>{{'csvLogs.filters.minRec' | translate}}</label>
				<input type="text" formControlName="minRec">
			</div>
			<div [ngClass]="this.isSmallScreen ? 'entry-2-small' : 'entry-4'" class="radio-group move-left-next">
				<input type="radio" id="insercion" value="insercion" formControlName="insertedUpdatedOrInvalid" (click)="handleRadioDates($event)">
                <label for="insercion">{{'csvLogs.filters.insert' | translate}}</label>
                <input type="radio" id="actualizacion" value="actualizacion" formControlName="insertedUpdatedOrInvalid" (click)="handleRadioDates($event)">
                <label for="actualizacion">{{'csvLogs.filters.update' | translate}}</label>
                <input type="radio" id="error" value="error" formControlName="insertedUpdatedOrInvalid" (click)="handleRadioDates($event)">
                <label for="error">{{'csvLogs.filters.invalid' | translate}}</label>
            </div>
			<div [ngClass]="this.isSmallScreen ? 'entry-2-small' : 'entry-4'"></div>
			<div [ngClass]="this.isSmallScreen ? 'entry-2-small' : 'entry-4'" class="calendar">
				<label>{{'global.fecha.inicio' | translate}}</label>
				<input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio"
				(click)="fechaInicio.open()">
				<mat-datepicker #fechaInicio></mat-datepicker>
			</div>
			<div [ngClass]="this.isSmallScreen ? 'entry-2-small' : 'entry-4'" class="calendar">
				<label>{{'global.fecha.fin' | translate}}</label>
				<input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin"
				(click)="fechaFin.open()">
				<mat-datepicker #fechaFin></mat-datepicker>
			</div>
			<div [ngClass]="this.isSmallScreen ? 'entry-2-small' : 'entry-4'"></div>
			<div *ngIf="!this.isSmallScreen" [ngClass]="this.isSmallScreen ? 'entry-2-small' : 'entry-4'"></div>
		</form>
	</section>
	<section class="filters-buttons">
		<button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
		(click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
			<i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
		</button>
		<button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
		(click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
			<i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
		</button>
		<button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
	</section>
	<div class="table-wrapper">
		<div class="table-container">
			<table>
				<thead>
					<tr>
						<th class="date sortable" (click)="toOrderBy('x=> x.fechaIns', 1)">
							{{'csvLogs.table.date' | translate}}
							<div class="sortable-icons"><i [ngClass]="getIcon('x=> x.fechaIns')"></i></div>
						</th>
						<th class="date">{{'csvLogs.table.time' | translate}}</th>
						<th class="string">{{'csvLogs.table.entityType' | translate}}</th>
						<th class="string">{{'csvLogs.table.total' | translate}}</th>
						<th class="string">{{'csvLogs.table.insert' | translate}}</th>
						<th class="string">{{'csvLogs.table.update' | translate}}</th>
						<th class="string">{{'csvLogs.table.invalid' | translate}}</th>
						<th class="string">{{'csvLogs.table.user' | translate}}</th>
						<th class="action"></th>
					</tr>
				</thead>
				<tbody *ngFor="let csvLog of csvLogs; let i = index; trackBy: trackByCsvLogId">
					<tr>
						<td class="date">{{csvLog.fechaIns | date: 'short' : undefined : defaultLanguage}}</td>
						<td class="date">{{csvLog.fechaIns | date: 'HH:mm'}}</td>
						<td class="string">{{getCsvType(csvLog.tipoImportCsvId)}}</td>
						<td class="string">{{csvLog.nRegTotal}}</td>
						<td class="string">{{csvLog.nRegIns}}</td>
						<td class="string">{{csvLog.nRegUpd}}</td>
						<td class="string">{{csvLog.nRegError}}</td>
						<td class="string">{{csvLog.userName}}</td>
						<td class="actions">
                            <i class="fas fa-stream" (click)="showSection(i, csvLog.nombreArchivoErrores, csvLog.tipoImportCsvId)"
                                title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
                            <i class="fas fa-file-csv" (click)="downloadCsvLog(csvLog.nombreArchivoErrores, csvLog.tipoImportCsvId)"
                                title="{{'titles.exportarCSV' | translate}}"></i>
						</td>
					</tr>
					<tr *ngIf="dropdownSection === i">
                        <td colspan="9">
                            <section class="tabs">
								<ul>
									<li [ngClass]="{'active': pestanaActiva[i] === 1}">{{'csvLogs.noImportado' | translate}}</li>
								</ul>
								<content>
									<app-csv-logs-registros-no-importados [csvFileName]="csvFileName" [csvTypeId]="csvTypeId" [csvTypes]="csvTypes" *ngIf="pestanaActiva[i] === 1"></app-csv-logs-registros-no-importados>
								</content>
                            </section>
                        </td>
                    </tr>
				</tbody>
				<tfoot *ngIf="!csvLogs || (csvLogs && csvLogs.length < 1)">
                    <tr>
                        <td colspan="9">
                            {{'global.noContent' | translate}}
                        </td>
                    </tr>
                </tfoot>
			</table>
		</div>
	</div>
	<app-toast *ngIf="(showError) && mensajes" [messages]="mensajes" (closed)="showError=$event">
    </app-toast>
</div>